<template>
  <div class="page-container">
    <div v-if="showLoading" class="loading-text">加载中...</div>
    <div v-else class="image-wrapper">
      <img :src="backgroundImage" class="background-image" />
      <div
        v-for="(hotspot, index) in indexHotspots"
        :key="index"
        class="hotspot-area"
        :style="getHotspotStyle(hotspot)"
        @click="handleHotspotClick(hotspot, index)"
      >
        <img
          v-if="hotspot.bottomImg"
          :src="getImageUrl(hotspot.bottomImg)"
          class="hotspot-image"
          :style="{ width: (hotspot.sizeWidth || 80) + 'px', height: (hotspot.sizeHeight || 80) + 'px' }"
        />
      </div>
    </div>

    <div v-if="showContentDialog" class="content-dialog-overlay" @click="hideContentDialog">
      <div class="content-dialog-container" @click.stop>
        <div class="content-dialog-header">
          <span class="content-dialog-title">活动规则</span>
          <span class="content-dialog-close" @click="hideContentDialog">×</span>
        </div>
        <div class="content-dialog-body" v-html="contentHtml"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSignStoreActivityDetailByCode, getSignStoreActivityDetail } from '@/api/signstore'
import { getImageUrl } from '@/utils/image'
import { Toast } from 'vant'

/**
 * 活动首页模板（与小程序 activity3 逻辑一致，同一配置双端使用）
 * 设计稿基准：宽 750，高 1334；热点用百分比 left/top + sizeWidth/sizeHeight
 */
export default {
  name: 'Activity3',
  data() {
    return {
      showLoading: true,
      backgroundImage: '',
      activityId: null,
      activityCode: null,
      indexHotspots: [],
      showContentDialog: false,
      contentHtml: '',
      designWidth: 750,
      designHeight: 1334
    }
  },
  mounted() {
    const activityCode = this.$route.query.activity_code
    const activityId = this.$route.query.id
    if (activityCode) {
      this.activityCode = activityCode
      this.loadActivity()
    } else if (activityId) {
      this.activityId = activityId
      this.loadActivity()
    } else {
      Toast('活动不存在或已结束')
      setTimeout(() => this.$router.replace('/index'), 1500)
    }
  },
  methods: {
    getImageUrl,
    getHotspotStyle(hotspot) {
      const sizeW = hotspot.sizeWidth || 80
      const sizeH = hotspot.sizeHeight || 80
      return {
        left: (hotspot.left !== undefined ? hotspot.left : 0) + '%',
        top: (hotspot.top !== undefined ? hotspot.top : 0) + '%',
        width: sizeW + 'px',
        height: sizeH + 'px'
      }
    },
    async loadActivity() {
      try {
        let res
        if (this.activityCode) {
          res = await getSignStoreActivityDetailByCode({ activityCode: this.activityCode })
        } else if (this.activityId) {
          res = await getSignStoreActivityDetail({ id: this.activityId })
        } else {
          throw new Error('活动ID或编码不存在')
        }
        if (!res || res.status !== 200) throw new Error((res && res.msg) || '获取活动详情失败')
        const activityData = res.data
        if (!activityData) throw new Error('活动数据为空')

        let pageConfig = activityData.pageConfig || {}
        if (activityData.pageConfigJson) {
          try {
            pageConfig = typeof activityData.pageConfigJson === 'string'
              ? JSON.parse(activityData.pageConfigJson)
              : activityData.pageConfigJson
          } catch (e) {
            console.error('解析 pageConfigJson 失败:', e)
          }
        }

        this.backgroundImage = getImageUrl(pageConfig.backgroundIndex || '') || pageConfig.backgroundIndex || ''
        if (!this.backgroundImage) Toast('未配置背景图片')
        this.indexHotspots = Array.isArray(pageConfig.indexHotspots) ? pageConfig.indexHotspots : []
        if (activityData.id) this.activityId = activityData.id
        if (activityData.activityCode) this.activityCode = activityData.activityCode
        this.showLoading = false
      } catch (error) {
        this.showLoading = false
        Toast(error.message || '加载活动失败')
      }
    },
    handleHotspotClick(hotspot) {
      if (!hotspot) return
      if (hotspot.checkType === 'start') {
        const q = {}
        if (this.activityId != null) q.id = this.activityId
        if (this.activityCode) q.activity_code = this.activityCode
        const query = new URLSearchParams(q).toString()
        this.$router.push('/template/activity3-1' + (query ? '?' + query : ''))
      } else if (hotspot.checkType === 'rule') {
        if (hotspot.content) {
          this.contentHtml = hotspot.content
          this.showContentDialog = true
        } else {
          Toast('暂无内容')
        }
      }
    },
    hideContentDialog() {
      this.showContentDialog = false
      this.contentHtml = ''
    }
  }
}
</script>

<style scoped lang="less">
.page-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
  padding: 0;
  margin: 0;
}

.image-wrapper {
  position: relative;
  width: 100%;
  min-height: 0;
  padding-bottom: calc(1334 / 750 * 100%);
  background: #f5f5f5;
}

.background-image {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: auto;
  display: block;
}

.hotspot-area {
  position: absolute;
  background: transparent;
  z-index: 10;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
}

.hotspot-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.content-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.content-dialog-container {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 340px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.content-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.content-dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.content-dialog-close {
  font-size: 24px;
  color: #999;
  cursor: pointer;
}

.content-dialog-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  font-size: 14px;
  color: #333;
  line-height: 1.8;
}

.loading-text {
  color: #666;
  font-size: 14px;
  padding: 40px;
}
</style>
